export enum EAddJobValidationType {
    Valid,
    DuplicatedName,
    DuplicatedExternalId,
    DuplicatedCostCode,
    NotAllowed,
    EmptyName
}
